import { IconButton } from '@creditornot/cb-button';
import { ArrowLeft, ArrowRight, Menu } from '@creditornot/cb-icons';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { useDirection } from '@creditornot/cb-provider';
import { Location, LocationDescriptor } from 'history';
import React, { ReactNode } from 'react';
import { useHistory } from 'react-router';
import styled from 'styled-components';

import { Typography } from 'common/typography';

import { useExperienceModuleContext } from '../../context';

type MobileHeaderProps = {
  title: string | ReactNode;
  backLink?: string | ((location: Location) => LocationDescriptor);
};

const MobileHeaderContainer = styled.div`
  display: flex;
  width: 100%;
  height: 84px;
  align-items: center;
  justify-content: space-between;
  border-block-end: 1px solid ${cbSemanticCssVars.borderPrimary};
  padding: 24px 16px;
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: ${cbSemanticCssVars.surfaceMain};
`;

const LeftContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 36px;
`;

export const MobileHeader = ({ title, backLink }: MobileHeaderProps) => {
  const { isSidebarOpen, setIsSidebarOpen } = useExperienceModuleContext();
  const cbDirection = useDirection();
  const history = useHistory();

  const handleBack = () => {
    backLink && history.push(typeof backLink === 'string' ? backLink : backLink(history.location));
  };

  return (
    <MobileHeaderContainer>
      <LeftContainer>
        <IconButton variant="grey" size="small" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
          <Menu />
        </IconButton>
        {backLink && (
          <IconButton variant="grey" size="small" onClick={handleBack}>
            {cbDirection === 'ltr' ? <ArrowLeft /> : <ArrowRight />}
          </IconButton>
        )}
        <Typography.Heading6>{title}</Typography.Heading6>
      </LeftContainer>
    </MobileHeaderContainer>
  );
};
